import { Label } from "@mui/icons-material";
import { useOperatorUsers } from "./OperatorUsersContext";
import { CircularProgress, Box, Typography, TableCell, Button } from "@mui/material";
import { Link } from "react-router-dom/dist";
import { DataGrid } from "@mui/x-data-grid";
import { OperatorUserModel } from "./utils";


const OperatorUsersList = () => {
    const { operatorUsers, setSelectedOperatorUser, setOperatorUser } = useOperatorUsers();

    const viewEditLinkIcon = (item) => {
        return(
            <Link className= 'hyper-links' onClick={(e) => setSelectedOperatorUser(item)}>
                {item.id}
            </Link>
        )
    }

    const disproles = (operAcc) => {
        return(
            operAcc.roles.map((eachrole, idx) => {
               return eachrole
            })
        )

    }

    const convertDateISOToUTC = (isoDate) => {
        if(isoDate !== null && isoDate !=="" ){
            const date = new Date(isoDate);
            const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
            return utcFormatted
        }
    }

    const dataGridColumns = [
        { field: 'id', headerName: 'Id', filterable: true, sortable: true, renderCell: (params) => viewEditLinkIcon(params.row) },
        { field: 'login', headerName: 'Login', filterable: true, sortable: true, width:150 },
        { field: 'name', headerName: 'Name', filterable: true, sortable: true, width: 200 },
        { field: 'organization', headerName: 'Organization', filterable: true, sortable: true, width: 200 },
        { field: 'email', headerName: 'Email', filterable: true, sortable: true, width: 250 },
        { field: 'agencyName', headerName: 'Agency', filterable: true, sortable: true },
        { field: 'roles', headerName: 'Roles', filterable: true, sortable: true, renderCell:(params) => disproles(params.row) },
        { field: 'approved', headerName: 'Approved', filterable: true, sortable: true, width: 200, renderCell:(params) => convertDateISOToUTC(params.row.approved) },
        { field: 'updated', headerName:'Updated', filterable: true, sortable: true, width: 200, renderCell:(params) => convertDateISOToUTC(params.row.updated) }
    ]

    if(operatorUsers !== null && operatorUsers.length > 0){
        return(
            <>
                <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}> Manage Operator User Accounts </Typography>
                <TableCell >
                    <Button variant="contained" onClick={(e) => setOperatorUser(OperatorUserModel)} > Create New Operator User </Button>
                </TableCell>
                <DataGrid rows={operatorUsers} columns={dataGridColumns} disableSelectionOnClick sx={{'& .MuiDataGrid-columnHeaders':{ fontSize:'1rem',fontWeight:'bold',display:'flex'}}}/>
            </>  
        )
    }
    else {
        return (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
                <CircularProgress/>
            </Box>
        )
    }
};

export default OperatorUsersList;